if (!customElements.get('stock-counter')) {
  customElements.define(
    'stock-counter',
    class StockCounter extends HTMLElement {
      constructor() {
        super();
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        try {
          this.sectionId = this.dataset.sectionId;
          this.textElement = this.querySelector('.stock-counter__text');
          this.variants = JSON.parse(this.querySelector('.stock-counter__variants')?.textContent || '[]');
          this.variantUnsubscriber =
            typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
              ? subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange)
              : null;
          this.closest('product-info')?.addEventListener('variant:changed', this.onVariantChange);
        } catch (error) {
          console.error(error);
        }
      }

      disconnectedCallback() {
        this.variantUnsubscriber?.();
        this.closest('product-info')?.removeEventListener('variant:changed', this.onVariantChange);
      }

      onVariantChange(event) {
        const detail = event?.detail || event?.data || event;
        const payload = detail?.data || detail;
        if (payload?.sectionId && payload.sectionId !== this.sectionId) return;
        const variant = payload?.variant || this.variants.find((entry) => String(entry.id) === String(payload?.variant?.id));
        this.render(variant);
      }

      render(variant) {
        const inventory = Number(variant?.inventory_quantity || 0);
        const tracked = variant?.inventory_management === 'shopify';
        const shouldShow = tracked && inventory > 0 && inventory <= 5;
        this.hidden = !shouldShow;
        if (!shouldShow || !this.textElement) return;
        this.textElement.textContent = this.dataset.lowStockTemplate.replace('__count__', inventory);
      }
    }
  );
}
